import { createSlice } from "@reduxjs/toolkit";

const createQosItems = () => {
  return Array.from({ length: 64 }, (_, number) => ({
    number,
    cos: null,
    defaultCos: null,
    savedCos: -1,
    modified: false,
  }));
};

const modifiedItems = {
  1: { cos: 1, modified: true },
  46: { cos: 5, modified: true },
};

let fakeData = createQosItems().map((item) => {
  return modifiedItems[item.number]
    ? { ...item, ...modifiedItems[item.number], defaultCos: 0, savedCos: modifiedItems[item.number].cos }
    : item;
});

const initialState = {
  resource: "wiredQos",
  data: {},
};

export const wiredQosSlice = createSlice({
  name: "wiredQos",
  initialState,
  reducers: {
    setWiredQosData: (state) => {
      const defaultValues = createQosItems().map(() => 0); // 模擬預設值全為 0
      state.data = {
        id: "72f31915-1a91-4996-9284-17ae038226ed",
        defaultValues,
        dscpValues: fakeData.map((item) => (item.modified ? item.cos : -1)),
      };
    },
    updateWiredQosData: (state, action) => {
      const dscpValues = action.payload?.dscpValues || [];
      const defaultValues = createQosItems().map(() => 0); // 模擬預設值全為 0
      fakeData = dscpValues.map((val, dscp) => {
        const defaultVal = defaultValues[dscp];
        const currentCos = val !== -1 ? val : defaultVal;
        const isModified = currentCos !== defaultVal;
        return {
          number: dscp,
          cos: currentCos,
          defaultCos: defaultVal,
          savedCos: val,
          modified: isModified,
        };
      });
      state.data = {
        id: "72f31915-1a91-4996-9284-17ae038226ed",
        defaultValues,
        dscpValues: fakeData.map((item) => (item.modified ? item.cos : -1)),
      };
    },
  },
});

export const {
  setWiredQosData,
  updateWiredQosData,
} = wiredQosSlice.actions;

export default wiredQosSlice.reducer;
